import {
  bool,
  func,
  object,
  oneOf,
  string,
} from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
  Switch,
} from '@material-ui/core';

function SwitchControl(props) {
  const {
    events = {},
    label,
    name,
    onChange,
    size,
    type,
    value,
  } = props;

  const Control = type === 'checkbox'
    ? Checkbox
    : Switch;

  const handleChange = ({ target: { checked } }) => {
    const target = {
      name,
      value: checked,
    };
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  return (
    <FormControlLabel
      control={<Control
        checked={value}
        name={name}
        size={size}
        onChange={handleChange}
      />}
      label={label}
    />
  );
}

SwitchControl.defaultProps = {
  size: 'small',
  type: 'switch',
  value: false,
  onChange: () => { },
};

SwitchControl.propTypes = {
  events: object,
  label: string,
  name: string,
  size: oneOf([
    'small',
    'medium',
  ]),
  type: oneOf([
    'checkbox',
    'switch',
  ]),
  value: bool,
  onChange: func,
};

export default SwitchControl;
